import { Dispatch, ReactNode, SetStateAction } from "react";
import { DataGridInner, DataGridProvider } from ".";
import { PaginationState } from "@tanstack/react-table";

export type TDataGridTableSpacing = "xs" | "sm" | "lg";

export type TDataGridSelectedRowIds = Set<string>;

export type TDataGridRequestParams = {
  pageIndex: number;
  pageSize: number;
  sorting?: { id: string; desc?: boolean }[];
  filters?: { id: string; value: unknown }[];
};

export interface TDataGridProps<TData extends object> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: any[];
  data?: TData[];
  rowSelect?: boolean;
  onRowsSelectChange?: (selectedRowIds: TDataGridSelectedRowIds) => void;
  onFilterReset?: () => void; // Callback for when filters are reset
  hasActiveFilters?: boolean; // Flag to indicate if there are external active filters
  messages?: {
    loading?: ReactNode | string;
    empty?: ReactNode | string;
  };
  layout?: {
    cellsBorder?: boolean;
    tableSpacing?: TDataGridTableSpacing;
  };
  pagination?: {
    page?: number;
    size?: number;
    sizes?: number[];
    sizesInfo?: string;
    sizesLabel?: string;
    sizesDescription?: string;
    more?: boolean;
    moreLimit?: number;
    info?: string;
    totalPages?: number;
    totalItems?: number;
    setPagination?: Dispatch<SetStateAction<PaginationState>>;
  };
  sorting?: { id: string; desc?: boolean }[];
  filters?: { id: string; value: unknown }[];
  serverSide?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFetchData?: (params: any) => Promise<any>;
  loading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSubRows?: (params: any) => { [Key: string]: any }[];
}

const DataGrid = <TData extends object>(props: TDataGridProps<TData>) => {
  return (
    <DataGridProvider {...props}>
      <DataGridInner />
    </DataGridProvider>
  );
};

export { DataGrid };
